import { ChevronRight } from "lucide-react";
import { CTA, Layout, PageIntro } from "../components/Chrome";
import { MaskedLines, Reveal } from "../components/Motion";
import { categories, criteria } from "../data";

export default function Creators() {
  return (
    <Layout>
      <PageIntro
        eyebrow="Creator network"
        lines={[<>Creators for</>, <><em>every campaign brief.</em></>]}
        text="We curate creators based on what your campaign needs — not by handing over a generic database."
      />
      <section className="category-section section-pad">
        <div className="category-grid" data-testid="category-grid">
          {categories.map((item, index) => (
            <Reveal className="category-card" key={item} delay={(index % 5) * 0.05} y={24} data-testid={`category-${index + 1}`}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <h3>{item}</h3>
              <ChevronRight size={18} />
            </Reveal>
          ))}
        </div>
        <div className="selection-bar">
          <div>
            <Reveal as="span" className="eyebrow" y={14}>A considered shortlist</Reveal>
            <MaskedLines as="h2" inView lines={[<>Built around</>, <><em>your criteria.</em></>]} />
          </div>
          <div className="criteria">
            {criteria.map((item, i) => (
              <Reveal as="span" key={item} delay={i * 0.05} y={16} data-testid={`criterion-${i + 1}`}>{item}</Reveal>
            ))}
          </div>
        </div>
        <Reveal delay={0.15}><CTA to="/contact">Tell Us Your Brief</CTA></Reveal>
      </section>
    </Layout>
  );
}
